// ---------------------------------------------------------------------------
// compute-drop-index — pure drop-target math for key-based reorderable lists
// ---------------------------------------------------------------------------
//
// Generalized (key-array, data-attribute) version of the table reorder-plugin's
// pure math, so card lists and any other key-keyed list can share it. Returns
// the CURRENT index of the hovered item; the caller then moves the dragged item
// to occupy that slot (remove-then-insert-at-target-index). Net effect: dragging
// downward lands after the hovered item, upward lands before — because removal
// shifts indices.

/**
 * @param {readonly string[]} keys - current ordered keys.
 * @param {string} draggedKey
 * @param {HTMLElement | null} overEl - the hovered item element (carries the key attr).
 * @param {(el: HTMLElement) => string} getKey - reads an element's key.
 * @returns {number} target index, or -1 when indeterminate (no element, hovering
 *   itself, or an unknown key).
 */
export function computeDropIndex(keys, draggedKey, overEl, getKey) {
  if (!overEl) return -1;
  const overKey = getKey(overEl);
  if (!overKey || overKey === draggedKey) return -1;
  const overIndex = keys.indexOf(overKey);
  return overIndex >= 0 ? overIndex : -1;
}
